<template>
  <div>
    <div class="flex flex-item1 mar20-b goods-list">
      <el-table :data="orderGoodsList" style="width: 100%" header-row-class-name="gray3 tab-header" border cell-class-name="cell-td">
        <el-table-column width="500px">
          <template slot="header">货品</template>
          <template slot-scope="scope">
            <div class="flex pad15-lr pad15-b" :class="{ 'border-b': scope.row.orderGoodsGiftBo.length > 0 }">
              <div class="overflow flex-shrink mar12-r wh72">
                <img :src="scope.row.goodsPic + '?imageView2/1/w/72/h/72'" />
              </div>
              <div class="flex-auto flex flex-column justify-between">
                <div class="gray3 lh20">
                  <el-tag type="danger" size="mini" class="mar5-r" v-if="scope.row.optimizationCard == 1">优选</el-tag>
                  <el-tag type="danger" size="mini" class="mar5-r" v-if="scope.row.cfyCard == 1">处方药</el-tag>
                  <el-tag type="danger" size="mini" class="mar5-r" v-if="scope.row.preventCard == 1">防非</el-tag>
                  <template v-if="scope.row.goodsTagList && scope.row.goodsTagList.length">
                    <el-tag type="danger" size="mini" class="mar5-r" v-for="tag in scope.row.goodsTagList" :key="tag">{{ tag }}</el-tag>
                  </template>
                  {{ scope.row.goodsName }}
                </div>
                <div class="gray9 mar4-t">{{ scope.row.goodsSpec }}</div>
              </div>
            </div>
            <div v-if="scope.row.orderGoodsGiftBo.length > 0">
              <div class="flex pad15-lr pad15-tb" :class="{ 'border-t': index }" v-for="(gift, index) in scope.row.orderGoodsGiftBo" :key="gift.id">
                <div class="overflow flex-shrink mar12-r wh72">
                  <img :src="gift.giftGoodsPicUrl + '?imageView2/1/w/72/h/72'" />
                </div>
                <div class="flex-auto">
                  <div class="gray3 lh20">{{ gift.giftGoodsName }}</div>
                  <div class="gray9 mar4-t">{{ gift.giftGoodsSpec }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="价格">
          <template slot-scope="scope">
            <div class="f12 price-line" v-if="scope.row.sellPrice && !dataMasking">¥ {{ scope.row.sellPrice }}</div>
            <div class="gray3 mar30-t" style="height: 58px" v-if="dataMasking">****</div>
            <div v-else class="gray3 mar30-t" style="height: 58px" :class="{ 'line-after': scope.row.orderGoodsGiftBo && scope.row.orderGoodsGiftBo.length }">
              ¥ {{ scope.row.sellFactPrice }}
            </div>
            <template v-if="scope.row.orderGoodsGiftBo.length > 0">
              <div
                class="h103"
                :class="{ 'line-after': index != scope.row.orderGoodsGiftBo.length - 1 }"
                v-for="(gift, index) in scope.row.orderGoodsGiftBo"
                :key="gift.id"
              ></div>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="c" align="center" label="数量">
          <template slot-scope="scope">
            <div v-if="dataMasking" class="gray3 mar30-t" style="height: 58px">****</div>
            <div v-else class="gray3 mar30-t" style="height: 58px" :class="{ 'line-after': scope.row.orderGoodsGiftBo && scope.row.orderGoodsGiftBo.length }">
              x {{ scope.row.goodsQuantity }}
            </div>
            <div v-if="scope.row.orderGoodsGiftBo.length > 0">
              <div
                class="flex justify-center items-center flex-column h103"
                :class="{ 'line-after': index != scope.row.orderGoodsGiftBo.length - 1 }"
                v-for="(gift, index) in scope.row.orderGoodsGiftBo"
                :key="gift.id"
              >
                <div class="gray3">x {{ gift.giftQuantity }}</div>
                <div class="flex justify-center">
                  <div class="gift">{{ gift.promotionDtlId && gift.promotionDtlId != "0" ? "赠品" : "套餐" }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="d" align="center" label="实际收货数量">
          <template slot-scope="scope">
            <div class="fb gray3 justify-center mar30-t flex">
              <div v-if="dataMasking">****</div>
              <div v-else-if="scope.row.orderRefundGoodsBo.goodsQuantityAccum >= 0">
                x {{ (Math.round((scope.row.goodsQuantity - scope.row.orderRefundGoodsBo.goodsQuantityAccum) * 100 + Number.EPSILON) / 100).toFixed(2) }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="e" align="center" label="金额">
          <template slot-scope="scope">
            <div class="fb gray3 justify-center mar30-t flex">
              <div class="pad2-r">¥</div>
              <div v-if="dataMasking">****</div>
              <div v-else>{{ (Math.round(scope.row.goodsQuantity * scope.row.sellFactPrice * 100 + Number.EPSILON) / 100).toFixed(2) }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="flex flex-item1 mar20-b" v-if="orderGoodsGiftBoList && orderGoodsGiftBoList.length > 0">
      <el-table :data="orderGoodsGiftBoList" style="width: 100%" header-row-class-name="gray3 tab-header" border cell-class-name="cell-td">
        <el-table-column prop="" align="" label="赠品">
          <template slot-scope="scope">
            <div class="flex">
              <div class="overflow flex-shrink mar12-r wh72">
                <img :src="scope.row.giftGoodsPicUrl + '?imageView2/1/w/72/h/72'" />
              </div>
              <div class="flex flex-column justify-between">
                <div class="gray3 lh20">
                  <el-tag type="danger" size="mini" class="mar5-r">赠品</el-tag>
                  {{ scope.row.giftGoodsName }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="giftQuantity" align="center" label="数量">
          <template slot-scope="scope">
            <div class="gray3" v-if="scope.row.giftQuantity > 0">x {{ scope.row.giftQuantity }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../order/detail/detail.scss";
</style>

<script>
export default {
  name: "order_goods_info_dtl",
  props: {
    orderGoodsList: {
      type: Array,
    },
    orderGoodsGiftBoList: {
      type: Array,
    },
    dataMasking: { type: String },
  },
};
</script>
